import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { ICON_TEXT_BASE_CLASSNAME } from './Constants';
import { createIconText } from './IconText';
createComponents(".".concat(ICON_TEXT_BASE_CLASSNAME), createIconText, NO_PATTERN_BUSINESS_LOGIC);
